import {isPlatformBrowser} from "@angular/common";
import {Config} from "../common/config";
import {Renderer2} from '@angular/core';

export class DocumentUtil {
  public static createElement<K extends keyof HTMLElementTagNameMap>(tagName: K, options?: ElementCreationOptions): HTMLElementTagNameMap[K] | null {
    if (isPlatformBrowser(Config.platformId)) {
      return document.createElement(tagName, options);
    }
    return null;
  }

  public static getElementById(id: string): HTMLElement | null {
    if (isPlatformBrowser(Config.platformId)) {
      return document.getElementById(id);
    }
    return null;
  }

  public static setProperty(property: string, value: string | null, priority?: string): void {
    if (isPlatformBrowser(Config.platformId)) {
      document.documentElement.style.setProperty(property, value, priority);
    }
  }

  public static updateHeadAttribute(renderer: Renderer2, selectorId: string, property: string, value: string) {
    const htmlElement = renderer.selectRootElement('head', true);
    let selector = htmlElement.querySelector(`#${selectorId}`);
    if (selector) {
      selector.setAttribute(property, value);
    }
  }

  public static updateElementBody(renderer: Renderer2, root: string, selectorId: string, value: string) {
    const htmlElement = renderer.selectRootElement(root, true);
    let selector = htmlElement.querySelector(`#${selectorId}`);
    if (selector) {
      selector.innerHTML = value;
    }
  }
}
